<template>
    <div class="fd-com-container">
        <MyTitle theTitle="个人信息"/>
                <van-cell-group class="fd-com-scroll">
                    <div class="item-field">
                        <van-cell title="头像"/>
                        <img v-show="this.sex == 1" class="fd-head-portrait" src="../../assets/image/icon-grzxS.png" alt="">
                        <img v-show="this.sex == 2" class="fd-head-portrait" src="../../assets/image/rw.png" alt="">
                    </div>
                    <div class="item-field">
                         <van-field
                                v-model="formData.cLoginName"
                                required
                                label="用户名"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div class="item-field">
                        <van-field
                                v-model="formData.cUsertypeText"
                                required
                                label="用户类型"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div class="item-field" v-if="userType == 1">
                        <van-field
                                v-model="formData.cCardname"
                                required
                                label="真实姓名"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div v-if="userType == 2 || userType == 3">
                        <div class="item-field">
                            <van-field
                                    required
                                    v-model="formData.cDwmc"
                                    label="单位名称"
                                    class="left-field"
                                    placeholder=""
                            ></van-field>
                              <!-- right-icon="arrow"
                                    @click="editUserInfo(formData.cDwmc,'cDwmc','单位名称',false)" -->
                        </div>
                        <div class="item-field">
                            <van-field
                                    v-model="formData.cDwxzText"
                                    label="单位性质"
                                    class="left-field"
                            ></van-field>
                            <!-- right-icon="arrow"
                                    @click="editUserInfo(formData.cDwxz,'cDwxz','单位性质',true)" -->
                        </div>
                    </div>
                    <div class="item-field">
                        <van-field
                                required
                                v-model="formData.cZjlxText"
                                label="证件类型"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div class="item-field">
                        <van-field
                                required
                                v-model="formData.cZjh"
                                label="证件号码"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div class="item-field" v-if="userType == 2 || userType == 3">
                        <van-field
                                required
                                v-model="formData.cQyfr"
                                :label="showMC"
                                class="left-field"
                        ></van-field>
                    </div>
                    <div class="item-field" v-if="userType == 2 || userType == 3">
                        <van-field
                                required
                                v-model="formData.cFridentity"
                                label="身份证号"
                                class="left-field"
                                disabled
                        ></van-field>
                    </div>
                    <div v-if="userType == 1">
                        <div class="item-field">
                            <van-field
                                    required
                                    v-model="formData.cBirthdate"
                                    label="出生日期"
                                    class="left-field"
                                    disabled
                            ></van-field>
                        </div>
                        <div class="item-field">
                            <van-field
                                    required
                                    v-model="formData.nAge"
                                    label="年龄"
                                    class="left-field"
                                    disabled
                            ></van-field>
                        </div>
                        <div class="item-field">
                            <van-field
                                    required
                                    v-model="formData.cSexText"
                                    label="性别"
                                    class="left-field"
                                    disabled
                            ></van-field>
                        </div>
                        <div class="item-field">
                             <van-field
                                required
                                v-model="formData.cMzText"
                                readonly
                                label="民族"
                                right-icon="arrow"
                                placeholder="请选择民族"
                                @click="showMZPicker = true"
                        ></van-field>
                        <van-popup v-model="showMZPicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="columnsMZ"
                                    :default-index="0"
                                    @cancel="showMZPicker = false"
                                    @confirm="onMZConfirm"
                            ></van-picker>
                        </van-popup>
                        </div>
                    </div>
                    <div class="item-field">
                        <van-field
                                v-model="formData.cEmail"
                                label="邮箱"
                                class="left-field"
                        ></van-field>
                    </div>
                    <div class="item-field">
                        <!-- <van-field
                                v-model="formData.cGh"
                                label="固定电话"
                                class="left-field"
                        ></van-field> -->
                        <section class="fd-com-section">
                            <div class="fd-com-title">
                                固定电话
                            </div>
                            <van-field
                                v-model="cGh1"
                                label="区号"
                                placeholder="请输入区号"
                            ></van-field>
                            <van-field
                                v-model="cGh2"
                                label="电话号码"
                                placeholder="请输入电话号码"
                            ></van-field>
                            <van-field
                                v-model="cGh3"
                                label="分机号"
                                placeholder="请输入分机号"
                            ></van-field>
                        </section>
                    </div>
                    <div class="item-field" v-if="userType == 1">
                        <van-field
                                v-model="formData.cTxdz"
                                required
                                label="经常居住地"
                                class="left-field"
                        ></van-field>
                    </div>
                    <div class="item-field" v-if="userType == 2 || userType == 3">
                        <van-field
                                required
                                v-model="formData.cTxdz"
                                label="通讯地址"
                                class="left-field s-field"
                        ></van-field>
                    </div>
                    <!-- <div class="real-name-box"  v-if="this.logStatus != 1">
                        <van-button class="real-name-btn" type="primary" @click="initIdentifyQrCode">实名认证</van-button>
                    </div> -->
                </van-cell-group>
                <div class="fd-com-btn-container">
                    <van-button
                        type="info"
                        round
                        @click="saveUserInfo">
                        保存
                    </van-button>
                </div>
                <van-dialog
                        v-model="showIdentifyQrCode"
                        title="请用微信识别二维码, 完成实名认证"
                        showConfirmButton
                        confirmButtonColor="black"
                >
                    <img id="identify-code" :src="identifyQrCode"/>
                </van-dialog>
    </div>
</template>

<script>
import validate from "@/utils/validator/validator";
import { Notify, Dialog, Toast } from "vant";
import { typeRylx, typeGzdwlx, typeMz, typeXb } from "../../filters/index";
import MyTitle from "../../components/common/myTitle";
import { checkIdentify, getIDData, extend } from "../../utils/common";
import { columnsMZ } from "../../utils/option";
import {
  EmailRule,
  TxdzRule,
  GddhRule,
  QhRule, // 区号
  DhhmRule, //电话号码
  FjhRule, // 分机号
} from "@/utils/validator/rules";
export default {
  data() {
    return {
      userType: 1,
      sex: "",
      logStatus: "",
      showMZPicker: false,
      formData: {
        cLoginName: "", // 共有的 用户名
        cUsertype: "", // 共有的 用户类型
        cUsertypeText: "",
        cCardname: "", // 自然人 真实姓名
        cBirthdate: "", // 自然人 出生日期
        nAge: "", // 自然人 年龄
        cSex: "", // 自然人 性别
        cSexText: "", // 自然人 性别
        cMz: "1", // 自然人 民族
        cMzText: "汉族", // 自然人 民族
        cZjlx: "", // 自然人 证件类型
        cZjh: "", // 自然人 证件号
        cEmail: "", // 共有的 邮箱
        cGh: "", // 共有的 固定电话
        cTxdz: "", // 自然人 的地址（经常居住地）
        cDwmc: "", //非自然人 单位名称
        cDwxz: "", //非自然人 单位性质
        cDwxzText: "", //非自然人 单位性质
        cQyfr: "", //非自然人 企业法人
        cDwdz: "", //非自然人 通讯地址（单位地址）
        cPhoneno: "",
        nUsersource: "",
        cGh1: "",
        cGh2: "",
        cGh3: "",
      },
      isEdit: false,
      showEdit: "",
      showMC: "",
      columnsMZ: columnsMZ,
      identifyQrCode: "", // 实名认证二维码地址
      showIdentifyQrCode: false, // 是否显示实名认证二维码
      cGh_data: "",
      cGh1: "",
      cGh2: "",
      cGh3: "",
    };
  },
  created() {
    this.logStatus = window.sessionStorage.getItem("logSource");
    if (this.logStatus != 1) {
      this.formData.nUsersource = 2;
    }
    this.getUserInfo();
  },
  mounted() {},
  components: {
    MyTitle,
  },
  methods: {
    onMZConfirm: function (item) {
      this.formData.cMz = item.keyId;
      this.formData.cMzText = item.text;
      this.showMZPicker = false;
    },
    getUserInfo() {
      let url = this.formData.nUsersource == 2 ? "/wfyUserInfo" : "/info";
      //TODO
      // this.$axios.get('account/api/wfyUserInfo')
      this.$axios
        .get("account/api/info")
        .then((res) => {
          let data = res.data;
          console.log("看看返回的data====", data);
          this.formData = data;
          this.userType = data.cUsertype;
          this.formData.cUsertypeText = typeRylx(data.cUsertype);
          this.formData.cDwxzText = typeGzdwlx(data.cDwxz);
          this.formData.cMzText = typeMz(data.cMz);
          this.identifyAnalyzer(data.cZjh);
          if (data.cCertification == "true") {
            this.isEdit = true;
            this.showEdit = "";
          } else {
            this.isEdit = false;
            this.showEdit = "arrow";
          }
          if (this.userType == "1") {
            this.formData.cZjlxText = "居民身份证";
          } else {
            this.showMC = "法人/负责人";
            if (this.userType == "3") {
              this.showMC = "负责人";
            }
            this.formData.cZjlxText = "统一社会信用代码";
          }
          if (data.cGh != "undefined-undefined-undefined" && data.cGh) {
            var cGhStr = String(data.cGh);
            var cGh = extend([], cGhStr.split("-"));
            var cGh0 = String(cGh[0]);
            var cGh1 = String(cGh[1]);
            var cGh2 = String(cGh[2]);
            this.cGh1 = cGh0;
            this.cGh2 = cGh1;
            this.cGh3 = cGh2;
          } else {
            this.cGh1 = "";
            this.cGh2 = "";
            this.cGh3 = "";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //保存信息
    saveUserInfo() {
      if (this.cGh1 && this.cGh2 && this.cGh3) {
        this.formData.cGh = `${this.cGh1}-${this.cGh2}-${this.cGh3}`;
      } else {
        this.formData.cGh = "";
      }
      const validated = this.validateFormData();
      validated.then(() => {
        this.$axios
          .post("account/api/account/xcxedit", this.formData)
          .then((res) => {
            if (res.code != 200) {
              Notify(res.message);
              return;
            }
            Notify({ type: "success", message: "保存成功" });
            history.go(-1);
          })
          .catch(function () {
            Notify("系统异常");
          });
      });
    },
    //做信息项校验
    validateFormData: function () {
      // 校验规则
      let descriptor;
      descriptor = {
        //邮箱
        cEmail: new EmailRule(false),
        cGh: new GddhRule(false),
        cGh1: new QhRule(false),
        cGh2: new DhhmRule(false),
        cGh3: new FjhRule(false),
        cTxdz: new TxdzRule(1, true),
      };
      let validated = validate(descriptor, this.formData);
      return validated;
    },
    editUserInfo(item, attributeName, title, isShow) {
      if (this.isEdit && attributeName == "cMz") {
        return;
      }
      sessionStorage.setItem("userAttributeValue", JSON.stringify(item));
      sessionStorage.setItem(
        "userAttributeName",
        JSON.stringify(attributeName)
      );
      sessionStorage.setItem("userAttributeTitle", JSON.stringify(title));
      sessionStorage.setItem("userAttributeShow", isShow);
      sessionStorage.setItem(
        "userType",
        JSON.stringify(this.formData.cUsertype)
      );
      sessionStorage.setItem("userId", this.formData.cUserid);
      this.$router.push({
        path: "/editPersonCenter",
      });
    },
    initIdentifyQrCode: function () {
      let _this = this;
      let cUserid = {
        cUserid: _this.formData.cUserid,
      };
      _this.$axios
        .post("/account/api/account/getxcxyard", cUserid)
        .then((res) => {
          _this.identifyQrCode = res.data.url;
          _this.showIdentifyQrCode = true;
        });
      _this.ws = new WebSocket(
        `${
          "ws://172.16.193.92:8083/api/v1.0/web/socket/" +
          _this.formData.cUserid
        }`
      );
      // _this.ws.onmessage = function (e) {
      //     Notify({
      //         message: '实名认证成功',
      //         type: 'success',
      //     })
      //     _this.showIdentifyQrCode = false;
      //     _this.ws.onclose = function () {
      //         console.log("client：关闭连接");
      //     };
      // };
    },
    identifyAnalyzer: function (zjhm) {
      let correct = checkIdentify(zjhm);
      if (correct) {
        // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
        getIDData(zjhm).then((res) => {
          console.log("证件号码解析出来的东西====", res);
          let data = res.data;
          this.sex = data.cSex;
          this.formData.cBirthdate = data.cBirthdate;
          this.formData.nAge = data.nAge;
          this.formData.cSex = data.cSex;
          this.formData.cSexText = typeXb(data.cSex);
        });
      }
    },
  },
  beforeDestroy() {
    // let _this = this
    //  _this.ws.onclose = function () {
    //      console.log("client：关闭连接");
    //  };
  },
};
</script>

<style lang="less" scoped>
@import "../../font/iconfont.css";
.fd-com-container {
  .item-field {
    display: flex;
    position: relative;

    > img {
      height: 22px;
      position: absolute;
      z-index: 2;
      top: 10px;
      left: 12px;
    }
  }
}

.fd-apply-button {
  color: #ff3b59;
  background: linear-gradient(to right, white, white);
  width: 100%;
  height: 100%;
  line-height: 30px;
  font-size: 14px;
  border-radius: 15px;
  display: inline-block;
}

.fd-head-portrait {
  margin-left: 82%;
}

#identify-code {
  width: 100%;
}

/deep/.s-field::after {
  border: none !important;
}
</style>

